<template>
  <div>
    <h1>
      Open Burn - Electronic Open Burn Permit Portal
    </h1>
    <p>
      Welcome to the Cook County Department of Environment and Sustainability electronic Open Burn permit portal.
    </p>
    <div class="row justify-content-left">
      <div class="col-4 col-md-4">
        <a @click="newapp" style="color: white; cursor: pointer;" class="btn btn-primary btn-block">
          New Open Burn Permit Application
        </a>
      </div>
      <div class="col-5 col-md-5">
        <a @click="newrecapp" style="color: white; cursor: pointer;" class="btn btn-primary btn-block">
          New Recreational Open Burn Permit Application
        </a>
      </div>
      <div class="col-3 col-md-3">
        <a @click="search" style="color: white; cursor: pointer;" class="btn btn-primary btn-block">
          Complete Saved Application
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import { getLandingCallback, errorNotification } from '~/js/FormFunctions';

export default {
  name: 'Landing',
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
    };
  },
  mounted() {
    getLandingCallback()
      .then((data) => {
        this.registerUrl = `http://10.122.78.13/OneCookCounty/Account/Register?returnUrl=${data}`;
        this.loginUrl = `http://10.122.78.13/OneCookCounty/Account/Login?returnUrl=${data}`;
      }).catch((error) => {
        errorNotification('Error Getting Landing Callback');
      });
  },
  methods: {
    newapp() {
      this.$router.push({ name: 'OpenBurnApplication', query: this.$route.query });
    },
    newrecapp() {
      this.$router.push({ name: 'OpenBurnRecreationalApplication', query: this.$route.query });
    },
    search() {
      this.$router.push({ name: 'OpenBurnApplicationSearch' });
    },
  },
};

</script>
